export default __webpack_public_path__ + "static/media/MrsLan.8ed5d34d.jpg";